import { render, staticRenderFns } from "./Tree.vue?vue&type=template&id=dac40cae&scoped=true"
import script from "./Tree.vue?vue&type=script&lang=ts"
export * from "./Tree.vue?vue&type=script&lang=ts"
import style0 from "./Tree.vue?vue&type=style&index=0&id=dac40cae&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dac40cae",
  null
  
)

export default component.exports